import React from 'react'
import logo from '../../assets/images/OLDMUTUALLOGO.svg'
import './navbar.css'

function Navbar() {
  return (
    <>
      {/* OM top ribbon available on all pages */}
      <div className='om-ribbon-top'>
        <img src={logo} alt="Old Mutual" className="om-icon" />
      </div>
      {/* Existing navbar logo container (can be extended later) */}
      {/* <div className='logo-top-om'>
        <img src={logo} alt="logo" className='logo-img'/>
      </div> */}
    </>
  )
}

export default Navbar
